import { Injectable } from '@angular/core';

import { Http } from '@angular/http';

import { UserData } from './user-data';
import { CommonData } from './common-data';
import { NativeScriptHttpModule } from "nativescript-angular/http";
import { Events } from 'ionic-angular';
import { AlertController } from 'ionic-angular';

@Injectable()
export class AdditionalfieldsData {
  data: any;
  selectedKategorie: any;

  
  constructor(public http: Http, public common: CommonData
    , public userData: UserData
    , public events: Events
    , public alertCtrl: AlertController
    
      ) {
    this.data = [];

  }

  load(){
  }

  loadfields(table, recordid){
    return new Promise(resolve => {
      let params = JSON.stringify({ 
        table: table
        ,recordid: recordid
        ,token: this.userData.jwt
      });    

      this.http.post(this.common.baseurl+'additionalfields/loadfields',params)
        .subscribe(data => {          
          let response = data.json();          
          if(response.success === true){
            //console.log(response.data);  
            resolve(response.data);
          }
          else{  
            resolve([]);              
          }
        //resolve([this.data]);          
        }, error => {
          resolve([]);  
      });
    });   
  }  

  loadvalues(table, recordid){
    return new Promise(resolve => {
      let params = JSON.stringify({ 
        table: table
        ,recordid: recordid
        ,token: this.userData.jwt
      });    

      this.http.post(this.common.baseurl+'additionalfields/loadvalues',params)
        .subscribe(data => {          
          let response = data.json();          
          if(response.success === true){
            //console.log(response.data);  
            resolve(response.data);
          }
          else{  
            resolve([]);              
          }
        //resolve([this.data]);          
        }, error => {
          resolve([]);  
      });
    });   
  }    

  
  updateAdditionalfields(table, recordid, additionalfields){
    return new Promise(resolve => {
      let params = JSON.stringify({ 
        table: table
        ,recordid: recordid
        ,additionalfields: additionalfields
        ,token: this.userData.jwt
      });    
      //console.log(params);
      this.http.post(this.common.baseurl+'additionalfields/updateadditionalfields',params)
        .subscribe(data => {
          //console.log(data);
          let response = data.json();          
          if(response.success === true){   
              resolve(response.data);
          }
          else{  
            resolve(false);              
          }
        }, error => {
          resolve(false);  
      });
    });      
  }  


}



// WEBPACK FOOTER //
// ./src/providers/additionalfields-data.ts